import { createContext } from 'react';
import { SettingsDailySettlementsDto } from '@shared/api';
import { emptyFunc } from '@shared/react';

export interface IDailySettlementContext {
    refreshDailySettlement: () => void;
    dailySettlement: SettingsDailySettlementsDto | null;
    dailySettlementLoading: boolean;
}

export const DailySettlementContext = createContext<IDailySettlementContext>({
    refreshDailySettlement: emptyFunc,
    dailySettlement: null,
    dailySettlementLoading: false,
});
